type WriteTask = () => Promise<void>;

let chain: Promise<void> = Promise.resolve();

/**
 * Serializa gravações no Preferences (evita JSON.stringify concorrentes no APK).
 */
export function enqueuePreferencesWrite(task: WriteTask): Promise<void> {
  const run = chain.then(task, task);
  chain = run.catch(() => undefined);

  return run;
}
